import { createBrowserRouter } from 'react-router-dom';
import { Box } from '@mui/material';

import AuthenticatedRoot from "./pages/auth/root";
import Home from './pages/auth/Home';
import Landing from './pages/unauth/Landing';
import UnauthenticatedRoot from './pages/unauth/root';
import Inventory from './pages/auth/Inventory';
import Item from './pages/auth/inventory/Item';
import Logout from './pages/auth/Logout';
import ItemCategories from './pages/auth/ItemCategories';
import ItemCategory from './pages/auth/inventory/ItemCategory';
import Customers from './pages/auth/Customers';
import Configuration from './pages/auth/Configuration';
import Stripe from './pages/auth/configuration/Stripe';
import StripeOauth from './pages/auth/configuration/StripeOauth';
import StorefrontConfiguration from './pages/auth/configuration/Storefront';
import Customer from './pages/auth/customers/Customer';
import Orders from './pages/auth/Orders';
import Order from './pages/auth/order/Order';
import FullPageCalendar from './pages/auth/FullPageCalendar';
import Locations from './pages/auth/Locations';
import Checkout from './pages/auth/order/Checkout';
import StorePages from './pages/auth/StorePages';
import EditStorePage from './pages/auth/storePages/EditStorePage';
import PreviewStorePage from './pages/auth/storePages/PreviewStorePage';
import PublicStorePage from './pages/unauth/PublicStorePage';
import OrderConfirmation from './pages/unauth/storePage/OrderConfirmation';
import Taxes from './pages/auth/configuration/Taxes';
import Storefront from './pages/unauth/Storefront';
import StorefrontItemCategory from './pages/unauth/storefront/ItemCategory';
import StorefrontItem from './pages/unauth/storefront/Item';
import StorefrontCheckout from './pages/unauth/storefront/StorefrontCheckout';
import StorefrontOrderConfirmed from './pages/unauth/storefront/OrderConfirmation';
import Location from './pages/auth/locations/Location';
import StorefrontHome from './pages/unauth/storefront/StorefrontHome';
import Waivers from './pages/auth/configuration/Waivers';
import ReservationWaiver from './pages/unauth/ReservationWaiver';
import UpcomingDeliveries from './components/displays/reservations/UpcomingDeliveries';
import UpcomingReservations from './pages/auth/UpcomingReservations';
import UpcomingPickups from './components/displays/reservations/UpcomingPickups';
import UpcomingCustomerPickups from './components/displays/reservations/UpcomingCustomerPickups';
import UpcomingCustomerReturns from './components/displays/reservations/UpcomingCustomerReturns';
import Reservations from './pages/auth/Reservations';
import Reservation from './pages/auth/reservations/Reservation';
import Revenue from './pages/auth/Revenue';
import ErrorPage from './pages/auth/ErrorPage';

const authRoutes = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/deliveries",
    element: <UpcomingReservations>
      <UpcomingDeliveries />
    </UpcomingReservations>
  },
  {
    path: "/pickups",
    element: <UpcomingReservations>
      <UpcomingPickups />
    </UpcomingReservations>
  },
  {
    path: "/customer_pickups",
    element: <UpcomingReservations>
      <UpcomingCustomerPickups />
    </UpcomingReservations>
  },
  {
    path: "/customer_returns",
    element: <UpcomingReservations>
      <UpcomingCustomerReturns />
    </UpcomingReservations>
  },
  {
    path: "/item_categories",
    element: <ItemCategories />
  },
  {
    path: "/item_categories/:id",
    element: <ItemCategory />
  },
  {
    path: "/inventory",
    element: <Inventory />
  },
  {
    path: "/inventory/:id",
    element: <Item />
  },
  {
    path: "/orders",
    element: <Orders />
  },
  {
    path: "/orders/:id",
    element: <Order />
  },
  {
    path: "/orders/:id/checkout",
    element: <Checkout />
  },
  {
    path: "/reservations",
    element: <Reservations />
  },
  {
    path: "/reservations/:id",
    element: <Reservation />
  },
  {
    path: "/revenue",
    element: <Revenue />
  },
  {
    path: "/locations",
    element: <Locations />
  },
  {
    path: "/locations/:id",
    element: <Location />
  },
  {
    path: "/customers",
    element: <Customers />
  },
  {
    path: "/customers/:id",
    element: <Customer />
  },
  {
    path: "/store_pages",
    element: <StorePages />
  },
  {
    path: "/store_pages/:id",
    element: <EditStorePage />
  },
  {
    path: "/store_pages/:id/preview",
    element: <PreviewStorePage />
  },
  {
    path: "/configuration",
    element: <Configuration />
  },
  {
    path: "/configuration/stripe",
    element: <Stripe />
  },
  {
    path: "/configuration/stripe/oauth",
    element: <StripeOauth />
  },
  {
    path: "/configuration/taxes",
    element: <Taxes />
  },
  {
    path: "/configuration/storefront",
    element: <StorefrontConfiguration />
  },
  {
    path: "/configuration/waivers",
    element: <Waivers />
  },
  {
    path: "/calendar",
    element: <FullPageCalendar />
  },
  {
    path: "/stores/:id",
    element: <PublicStorePage />
  },
  {
    path: "/stores/:id/confirmation/:order_id",
    element: <OrderConfirmation />
  },
  {
    path: "/storefront/:organization_id",
    element: <Storefront />
  },
  {
    path: "/waivers/:waiverUuid/:reservationWaiverId",
    element: <ReservationWaiver />
  },
  {
    path: "/logout",
    element: <Logout />
  }
]

const storefrontSubroutes = [
  {
    path: "",
    element: <StorefrontHome />
  },
  {
    path: "items/:id",
    element: <StorefrontItem />
  },
  {
    path: "item_categories/:itemCategoryId",
    element: <StorefrontItemCategory />
  },
  {
    path: "checkout",
    element: <StorefrontCheckout />
  },
  {
    path: "order_confirmation",
    element: <StorefrontOrderConfirmed />
  }
]

const unauthRoutes = [
  {
    path: "/",
    element: <Storefront />,
    children: storefrontSubroutes
  },
  {
    path: "/stores/:id",
    element: <PublicStorePage />
  },
  {
    path: "/stores/:id/confirmation/:order_id",
    element: <OrderConfirmation />
  },
  {
    path: "/storefront/:organization_id",
    element: <Storefront />,
    children: storefrontSubroutes
  },
  {
    path: "/waivers/:waiverUuid/:reservationWaiverId",
    element: <ReservationWaiver />
  },
  {
    path: "/admin",
    element: <Landing />
  }
]

const authRouter = createBrowserRouter([
  {
    path: "/",
    element: <AuthenticatedRoot />,
    errorElement: <ErrorPage />,
    children: authRoutes,
  },
]);

const unauthRouter = createBrowserRouter([
  {
    path: "/",
    element: <UnauthenticatedRoot />,
    errorElement: <Box>Error</Box>,
    children: unauthRoutes,
  }
])

export { authRouter, unauthRouter }